import loadable from "@loadable/component";
import { ErrorBoundary } from "../../components";
import FullPageLoader from "@Components/FullPageLoader";

const AsyncListWithUsV2 = loadable(() => import("./ListWithUsV2"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => (
  <ErrorBoundary>
    <AsyncListWithUsV2 {...props} />
  </ErrorBoundary>
);
